import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import AutoSuggestField from "@FormElements/AutoSuggestField";
import FormContext from "formContext";
import axios from 'axios';
import Logger from '@ffw/logger-lib';

function SpecialismAutoSuggestField({intl, settings, ...rest}) {
  const {additionalData, setAdditionalData, currentStep, setFormData, formData, setErrors} = useContext(FormContext);

  const specialismsList = additionalData.specialisms && additionalData.specialisms.Specialisms;
  let specialismOptions = [];
  let specialismFiltered = [];
  if (specialismsList) {
    specialismOptions = Object.keys(specialismsList).map(function(key) {
      const object = specialismsList[key];
      if (formData && formData[currentStep] && formData[currentStep][settings.name]) {
        const formValue = formData[currentStep][settings.name];
        const match = object.Name.toLowerCase().indexOf(formValue.toLowerCase()) !== -1;

        if (match) {
          specialismFiltered.push(specialismsList[key].Name);
        }
      }
      return specialismsList[key];
    })
  }


  settings.options = specialismFiltered;

  rest.onChange = e => {
    const {value} = e.target;
    setErrors();
    const match = specialismOptions.find(el => el.Name === value);
    if (match) {
      setFormData(prev => {
        if (!prev[currentStep][settings.name]) {
          prev[currentStep][settings.name] = '';
        }
        prev[currentStep][settings.name] = match.Name;
        prev[currentStep]['job_title'] = '';
        prev[currentStep]['branch'] = '';
        prev[currentStep]['can_select_branch'] = true;
        return {
          ...prev
        }
      });
      fetchBranches(match.Name.toLowerCase());
    }
    else {
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        prev[currentStep][settings.name] = value;
        prev[currentStep]['job_title'] = '';
        prev[currentStep]['branch'] = '';
        prev[currentStep]['can_select_branch'] = false;
        return {
          ...prev
        }
      });
    }
  };

  const fetchBranches = specialismName => {
    // Fetch valid specialism id to get relevant branches.
    const specialism = additionalData.specialismOptions &&
      additionalData.specialismOptions.find((specialism) => specialism.name === specialismName.toLowerCase());

    if (specialism) {
      // Fetch branches by specialism id.
      axios.get(`${process.env.REACT_APP_API_PREFIX}/get-branches`, {skipInterceptor: true, params: specialism}).then(result => {
        const newOptions = [];
        if (result.data[specialismName] && result.data[specialismName].branches.length) {
          result.data[specialismName].branches.forEach(item => {
            if (item.hasOwnProperty('branchName') && item.hasOwnProperty('officeId')) {
              newOptions.push({
                value: item.officeId,
                label: item.branchName,
              })
            }
          });
          setAdditionalData(prev => {
            return {
              ...prev,
              branches: newOptions
            }
          });
        }
      })
      .catch(error => {
        Logger.error(`Error getting branch values: ${error.message}`, "SpecialismAutoSuggestFields/au");
      });
    }
    else {
      setAdditionalData(prev => {
        return {
          ...prev,
          branches: []
        }
      });
      setFormData(prev => {
        if (!prev[currentStep]) {
          prev[currentStep] = {};
        }
        prev[currentStep]['branch'] = '';
        prev[currentStep]['can_select_branch'] = false;
        return {
          ...prev
        }
      });
    }
  };

  return (
    <AutoSuggestField
      settings={settings}
      {...rest}
    />
  );
}

export default injectIntl(SpecialismAutoSuggestField);
